// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
ion-spinner {
  margin: 32px;
  height: 72px;
  width: 72px;
}

.payment-input {
  margin: 6px 12px;
  border-radius: 5px;
  padding: var(--ion-margin);
  color: var(--ion-color-black);
}

.header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  text-transform: uppercase;
}
.header ion-icon {
  width: 25px;
  height: 25px;
}
.header .back-icon {
  width: 20px;
  height: 20px;
}

.header-msg {
  font-size: 18px;
  font-family: AppFontMedium, sans-serif;
  font-weight: bold;
  text-transform: uppercase;
}

.payment-method-row {
  align-items: center;
  margin: 6px 12px;
  border-radius: 26px;
  border: 1px solid var(--color-black);
  text-transform: uppercase;
}
.payment-method-row > ion-col {
  padding: 0;
}
.payment-method-row > ion-col ion-item {
  overflow: hidden;
  --background: #00000000;
}
.payment-method-row > ion-col ion-item > ion-radio {
  --color: var(--ion-color-primary);
  --color-checked: var(--ion-color-primary);
  margin: 11px 16px 10px 4px;
}
.payment-method-row > ion-col ion-item > ion-label {
  color: var(--ion-color-black);
  font-family: AppFontMedium;
}

.back-icon {
  margin-right: 10px;
  width: 30px;
}

.bottom-end {
  position: absolute;
  bottom: 0;
  right: 0;
  height: 300px;
  width: 142px;
}

.padding-5 {
  padding: 5px;
}

ion-content {
  --background: #FAF7F6;
}

.icon-size {
  margin: 0px;
  zoom: var(--payment-icon-size);
}

.cash-block {
  display: flex;
  justify-content: center;
}
.cash-block ion-button {
  width: 60%;
  margin: 10px auto;
}

.payment-link {
  width: 100%;
  height: 100%;
  padding: 8px 15px;
  font-size: 16px;
  font-family: AppFont, sans-serif;
  text-transform: uppercase;
  background: #F48B7F;
  color: white;
  text-decoration: none;
  text-align: center;
  margin-bottom: 30px;
  border-radius: 28px;
}
.payment-link:hover {
  background: #FC5E07;
}

.bottom-separator {
  padding-top: 10px;
}

#customCard-container {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
#customCard-container label {
  display: flex;
  align-items: center;
  width: 100%;
}
#customCard-container label iframe {
  height: 50px;
}

/* Загальні стилі для картки */
#customCard-container {
  font-family: "Arial", sans-serif;
  padding: 20px;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 80%;
  margin: 0 auto;
}
#customCard-container ion-spinner {
  margin: 0 auto;
}

/* Стилі для полів форми */
#customCard-container .adyen-checkout__field-wrapper {
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
}

#customCard-container .adyen-checkout__label {
  font-size: 14px;
  color: #333;
  margin-bottom: 5px;
}

#customCard-container .adyen-checkout__input {
  padding: 10px;
  border: 1px solid #dcdcdc;
  border-radius: 4px;
  font-size: 16px;
  color: #333;
  background-color: #f9f9f9;
  transition: border-color 0.3s ease-in-out;
}

#customCard-container .adyen-checkout__input:focus {
  border-color: #007bff;
  outline: none;
}

/* Стилі для помилок */
#customCard-container .adyen-checkout__input--error {
  border-color: #ff4d4d;
  background-color: #ffe6e6;
}

#customCard-container .adyen-checkout__error-text {
  color: #ff4d4d;
  font-size: 12px;
  margin-top: 5px;
}

/* Кнопка оплати */
#payButton {
  width: 100%;
  padding: 12px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  background-color: var(--ion-color-primary);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;
  margin-top: 10px;
}
#payButton.hidden {
  visibility: hidden;
}

#payButton:hover {
  background-color: #218838;
}

#payButton:active {
  background-color: #1e7e34;
}

/* Відступи та вирівнювання для полів картки */
#customCard-container .adyen-checkout__card__form {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

#customCard-container .adyen-checkout__card__form .adyen-checkout__field-wrapper {
  flex: 1;
  min-width: 48%;
}

/* Стілі для основного контейнера */
.payment-modal-container {
  padding: 20px;
}

.payment-modal-container h2 {
  text-align: center;
  color: #333;
  margin-bottom: 20px;
}

.payment-modal-container .payment-method {
  margin-bottom: 20px;
}

.payment-modal-container .total-price {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  text-align: right;
}

.iframe-wrapper {
  position: relative;
  display: inline-block;
}

.iframe-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  background-color: rgba(255, 255, 255, 0.5); /* Напівпрозорий фон */
}

.input_data {
  width: 100%;
}

.added-gift {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 10px;
  border-bottom: 1px solid var(--color-black);
  border-top: 1px solid var(--color-black);
}
.added-gift .header-gift {
  width: 35px;
  height: 35px;
  min-height: 35px;
  min-width: 35px;
  background: #F48B7F;
  border: 1px solid var(--color-black);
  border-radius: 50%;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.added-gift .inner-text-gift {
  margin-left: 5px;
}
.added-gift .inner-text-gift h3 {
  font-family: AppFontMedium;
  text-transform: uppercase;
  font-size: 14px;
}
.added-gift .inner-text-gift p {
  font-family: AppFontMedium;
  text-transform: uppercase;
  font-size: 12px;
}
.added-gift .delete-items-section {
  margin-left: auto;
}
.added-gift ion-img {
  width: 45px;
}

.info-section {
  background: var(--ion-color-primary);
  padding: 20px;
  display: flex;
  align-items: center;
}
.info-section ion-icon {
  width: 45px;
  height: 45px;
  margin-right: 10px;
}
.info-section p {
  font-size: 12px;
  color: white;
  text-transform: uppercase;
}

.close-icon {
  margin: 0px;
  background: var(--color-white-accent);
  width: 35px;
  height: 35px;
  padding: 0px;
  z-index: 99;
}
.close-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.close-icon:hover {
  background: #f2dbd9;
}`, "",{"version":3,"sources":["webpack://./src/smoothr-web-app-core/components/payment-modal/payment-modal.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,YAAA;EACA,YAAA;EACA,WAAA;AAEF;;AACA;EACE,gBAAA;EACA,kBAAA;EACA,0BAAA;EACA,6BAAA;AAEF;;AAAA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;AAGF;AADE;EACE,WAAA;EACA,YAAA;AAGJ;AADE;EACE,WAAA;EACA,YAAA;AAGJ;;AACA;EACE,eAAA;EACA,sCAAA;EACA,iBAAA;EACA,yBAAA;AAEF;;AACA;EAEE,mBAAA;EACA,gBAAA;EAEA,mBAAA;EACA,oCAAA;EACA,yBAAA;AAAF;AACE;EACE,UAAA;AACJ;AACI;EACE,gBAAA;EACA,uBAAA;AACN;AACM;EACE,iCAAA;EACA,yCAAA;EACA,0BAAA;AACR;AAEM;EACE,6BAAA;EACA,0BAAA;AAAR;;AAMA;EACE,kBAAA;EACA,WAAA;AAHF;;AAMA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,YAAA;AAHF;;AAMA;EACE,YAAA;AAHF;;AAMA;EACE,qBAAA;AAHF;;AAMA;EACE,WAAA;EACA,8BAAA;AAHF;;AAMA;EACE,aAAA;EACA,uBAAA;AAHF;AAKE;EACE,UAAA;EACA,iBAAA;AAHJ;;AAMA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gCAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EAEA,mBAAA;EACA,mBAAA;AAJF;AAKE;EACE,mBAAA;AAHJ;;AAOA;EACE,iBAAA;AAJF;;AAMA;EACE,aAAA;EACE,eAAA;EACA,WAAA;AAHJ;AAII;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAFN;AAGM;EACE,YAAA;AADR;;AAKA,8BAAA;AACA;EACE,gCAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wCAAA;EACA,UAAA;EACE,cAAA;AAFJ;AAGI;EACE,cAAA;AADN;;AAKA,0BAAA;AACA;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;AAFF;;AAKA;EACE,eAAA;EACA,WAAA;EACA,kBAAA;AAFF;;AAKA;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;EACA,yCAAA;AAFF;;AAKA;EACE,qBAAA;EACA,aAAA;AAFF;;AAKA,sBAAA;AACA;EACE,qBAAA;EACA,yBAAA;AAFF;;AAKA;EACE,cAAA;EACA,eAAA;EACA,eAAA;AAFF;;AAKA,kBAAA;AACA;EACE,WAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,0CAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,6CAAA;EACA,gBAAA;AAFF;AAGE;EACE,kBAAA;AADJ;;AAKA;EACE,yBAAA;AAFF;;AAKA;EACE,yBAAA;AAFF;;AAKA,8CAAA;AACA;EACE,aAAA;EACA,eAAA;EACA,SAAA;AAFF;;AAKA;EACE,OAAA;EACA,cAAA;AAFF;;AAKA,mCAAA;AACA;EACE,aAAA;AAFF;;AAKA;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,iBAAA;AAFF;;AAIA;EACE,kBAAA;EACA,qBAAA;AADF;;AAIA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,0CAAA,EAAA,sBAAA;AADF;;AAGA;EACE,WAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,2CAAA;EACA,wCAAA;AAAF;AACE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AACJ;AACE;EACE,gBAAA;AACJ;AAAI;EACE,0BAAA;EACA,yBAAA;EACA,eAAA;AAEN;AAAI;EACE,0BAAA;EACA,yBAAA;EACA,eAAA;AAEN;AACE;EACE,iBAAA;AACJ;AACE;EACE,WAAA;AACJ;;AAEA;EACE,oCAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;AACF;AAAE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAEJ;AAAE;EACE,eAAA;EACA,YAAA;EACA,yBAAA;AAEJ;;AACA;EAEE,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AACF;AAAE;EACE,WAAA;EACA,YAAA;EACA,WAAA;AAEJ;AAAE;EACE,mBAAA;AAEJ","sourcesContent":["ion-spinner {\n  margin: 32px;\n  height: 72px;\n  width: 72px;\n}\n\n.payment-input {\n  margin: 6px 12px;\n  border-radius: 5px;\n  padding: var(--ion-margin);\n  color: var(--ion-color-black);\n}\n.header {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  text-transform: uppercase;\n\n  ion-icon {\n    width: 25px;\n    height: 25px;\n  }\n  .back-icon {\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.header-msg {\n  font-size: 18px;\n  font-family: AppFontMedium, sans-serif;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n.payment-method-row {\n\n  align-items: center;\n  margin: 6px 12px;\n\n  border-radius: 26px;\n  border: 1px solid var(--color-black);\n  text-transform: uppercase;\n  > ion-col {\n    padding: 0;\n\n    ion-item {\n      overflow: hidden;\n      --background: #00000000;\n\n      > ion-radio {\n        --color: var(--ion-color-primary);\n        --color-checked: var(--ion-color-primary);\n        margin: 11px 16px 10px 4px;\n      }\n\n      > ion-label {\n        color: var(--ion-color-black);\n        font-family: AppFontMedium;\n      }\n    }\n  }\n}\n\n.back-icon {\n  margin-right: 10px;\n  width: 30px;\n}\n\n.bottom-end {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  height: 300px;\n  width: 142px;\n}\n\n.padding-5 {\n  padding: 5px;\n}\n\nion-content {\n  --background: #FAF7F6;\n}\n\n.icon-size {\n  margin: 0px;\n  zoom: var(--payment-icon-size);\n}\n\n.cash-block {\n  display: flex;\n  justify-content: center;\n\n  ion-button {\n    width: 60%;\n    margin: 10px auto;\n  }\n}\n.payment-link {\n  width: 100%;\n  height: 100%;\n  padding: 8px 15px;\n  font-size: 16px;\n  font-family: AppFont, sans-serif;\n  text-transform: uppercase;\n  background: #F48B7F;\n  color: white;\n  text-decoration: none;\n  text-align: center;\n\n  margin-bottom: 30px;\n  border-radius: 28px;\n  &:hover {\n    background: #FC5E07;\n  }\n}\n\n.bottom-separator {\n  padding-top: 10px;\n}\n#customCard-container {\n  display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n    label {\n      display: flex;\n      align-items: center;\n      width: 100%;\n      iframe {\n        height: 50px;\n      }\n    }\n}\n/* Загальні стилі для картки */\n#customCard-container {\n  font-family: 'Arial', sans-serif;\n  padding: 20px;\n  border: 1px solid #dcdcdc;\n  border-radius: 8px;\n  background-color: #fff;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  width: 80%;\n    margin: 0 auto;\n    ion-spinner{\n      margin:  0 auto;\n    }\n}\n\n/* Стилі для полів форми */\n#customCard-container .adyen-checkout__field-wrapper {\n  margin-bottom: 15px;\n  display: flex;\n  flex-direction: column;\n}\n\n#customCard-container .adyen-checkout__label {\n  font-size: 14px;\n  color: #333;\n  margin-bottom: 5px;\n}\n\n#customCard-container .adyen-checkout__input {\n  padding: 10px;\n  border: 1px solid #dcdcdc;\n  border-radius: 4px;\n  font-size: 16px;\n  color: #333;\n  background-color: #f9f9f9;\n  transition: border-color 0.3s ease-in-out;\n}\n\n#customCard-container .adyen-checkout__input:focus {\n  border-color: #007bff;\n  outline: none;\n}\n\n/* Стилі для помилок */\n#customCard-container .adyen-checkout__input--error {\n  border-color: #ff4d4d;\n  background-color: #ffe6e6;\n}\n\n#customCard-container .adyen-checkout__error-text {\n  color: #ff4d4d;\n  font-size: 12px;\n  margin-top: 5px;\n}\n\n/* Кнопка оплати */\n#payButton {\n  width: 100%;\n  padding: 12px;\n  font-size: 16px;\n  font-weight: bold;\n  color: #fff;\n  background-color: var(--ion-color-primary);\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s ease-in-out;\n  margin-top: 10px;\n  &.hidden {\n    visibility: hidden;\n  }\n}\n\n#payButton:hover {\n  background-color: #218838;\n}\n\n#payButton:active {\n  background-color: #1e7e34;\n}\n\n/* Відступи та вирівнювання для полів картки */\n#customCard-container .adyen-checkout__card__form {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n#customCard-container .adyen-checkout__card__form .adyen-checkout__field-wrapper {\n  flex: 1;\n  min-width: 48%;\n}\n\n/* Стілі для основного контейнера */\n.payment-modal-container {\n  padding: 20px;\n}\n\n.payment-modal-container h2 {\n  text-align: center;\n  color: #333;\n  margin-bottom: 20px;\n}\n\n.payment-modal-container .payment-method {\n  margin-bottom: 20px;\n}\n\n.payment-modal-container .total-price {\n  font-size: 18px;\n  font-weight: bold;\n  color: #333;\n  text-align: right;\n}\n.iframe-wrapper {\n  position: relative;\n  display: inline-block;\n}\n\n.iframe-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  background-color: rgba(255, 255, 255, 0.5); /* Напівпрозорий фон */\n}\n.input_data {\n  width: 100%;\n}\n\n.added-gift {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 10px 10px;\n  border-bottom: 1px solid var(--color-black);\n  border-top: 1px solid var(--color-black);\n  .header-gift {\n    width:35px;\n    height: 35px;\n    min-height: 35px;\n    min-width: 35px;\n    background: #F48B7F;\n    border: 1px solid var(--color-black);\n    border-radius: 50%;\n    font-size: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n  }\n  .inner-text-gift {\n    margin-left: 5px;\n    h3 {\n      font-family: AppFontMedium;\n      text-transform: uppercase;\n      font-size: 14px;\n    }\n    p {\n      font-family: AppFontMedium;\n      text-transform: uppercase;\n      font-size: 12px;\n    }\n  }\n  .delete-items-section {\n    margin-left: auto;\n  }\n  ion-img {\n    width: 45px;\n  }\n}\n.info-section {\n  background: var(--ion-color-primary);\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  ion-icon {\n    width: 45px;\n    height: 45px;\n    margin-right: 10px;\n  }\n  p {\n    font-size: 12px;\n    color: white;\n    text-transform: uppercase;\n  }\n}\n.close-icon {\n\n  margin: 0px;\n  background: var(--color-white-accent);\n  width: 35px;\n  height: 35px;\n  padding: 0px;\n  z-index: 99;\n  ion-icon {\n    width: 100%;\n    height: 100%;\n    margin: 0px;\n  }\n  &:hover {\n    background: #f2dbd9;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
